import React, { useEffect, useState } from "react"
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import BlockRenderer from "../components/structured-text/block-renderer";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";
import NewsletterNinetyFine from "../components/structured-text/blocks/newsletter-ninety-five"

const setCookie = (name, value, days) => {
  if (typeof document !== "undefined") {
    let expires = ""
    if (days) {
      let date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/"
  }
}

const getCookie = (name) => {
  if (typeof document !== "undefined") {
    let nameEQ = name + "="
    let ca = document.cookie.split(";")
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === " ") c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
  }
  return false
}

const Page = ({ pageContext, data }) => {
  const [news, setNews] = useState(false)

  const newsPopup = () => {
    if (getCookie("newsletter-95-popup")) return
    setTimeout(() => {
      setNews(true)

      return () => {
        setCookie("newsletter-95-popup", "done", 365)
      }
    }, 6000)
  }

  useEffect(() => {
    newsPopup()
  }, [])

  const closeNewsletter = () => {
    setNews(false)
    setCookie("newsletter-95-popup", "done", 365)
  }

    return (
      <>
        <DraftDebug publishedAt={data?.datoCmsPage?.meta?.publishedAt} />
        <HelmetDatoCms seo={data?.datoCmsPage?.seoMetaTags}>
          <body
            className={`page-template page-template--${data?.datoCmsPage?.slug === "index" ? "home" : data?.datoCmsPage?.slug}`} />
        </HelmetDatoCms>
        { data.datoCmsPage.slug !== '1929' &&
          <div className={`newsletter__popup ${news ? "active" : ""}`} onClick={() => closeNewsletter()}>
            <NewsletterNinetyFine onClick={() => closeNewsletter()} />
          </div>
        }
        <BlockRenderer data={data?.datoCmsPage?.blocks} />
      </>
    )
}

export const query = graphql`
    query PageTemplate ($originalId: String!) {
        datoCmsPage(originalId: { eq: $originalId }) {
            seoMetaTags {
                tags
            }
            slug
            jsonLd
            meta {
                publishedAt
            }
            blocks {
                __typename
                ...LandingBannerProps
                ...TitleContentListImageProps
                ...AwardsCtaProps
                ...TitleCardItemProps
                ...TitleBrandItemProps
                ...TitleClientProps
                ...BannerCtaProps
                ...TitleHeaderProps
                ...ImageHeaderProps
                ...TeamArchiveProps
                ...DistributorArchiveProps
                ...ExpertiseBannerProps
                ...TitleContentImageProps
                ...TestimonialProps
                ...PartnershipProps
                ...TitleContentVideoProps
                ...TitleContentItemProps
                ...TitleVideoProps
                ...StatsItemProps
                ...PromoProps
                ...ProductCtaProps
                ...ArticleArchiveProps
                ...RecipeArchiveProps
                ...BasicCtaProps
                ...StickyCardProps
                ...RangeSliderItemProps
                ...TitleContentImageButtonProps
                ...TitleGalleryProps
                ...TitleContentVideoItemProps
                ...ImageBannerProps
                ...ReplicaLabelProps
                ...TeamSelectorProps
                ...MapLottieProps
                ...ContactProps
                ...TimelineProps
                ...CampaignVideoProps
                ...ThreeColumnItemProps
                ...ThankYouProps
                ...QuoteContentProps
                ...CampaignContentProps
                ...ImageIconContentProps
                ...TitleContentColumnProps
                ...TitleContentStickyProps
                ...SustainLandingProps
                ...ScrollCardProps
                ...ContentClientImageProps
            }
        }
    }
`
export default Page
